export default {
  categoryState: state => state.categoryList,
  categoryComponentReference: state => state.categoryComponentReference
}
